<template>
  <div class="className">
    <el-card class="anoCard">
      <el-form
        ref="dialogForm"
        :model="dialogForm"
        :rules="formRule"
        label-width="120px"
        class="el-form"
        width="500px"
      >
        <el-form-item label="banner名称:" prop="title">
          <el-input
            style="width: 220px"
            v-model="dialogForm.title"
            placeholder="请输入banner名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="banner图:" prop="fileProp">
          <div class="file-tip">图片要求：jpg, jpeg, png格式，小于2M</div>
          <UploadFile
            :limit="1"
            :fileList="fileList"
            :fileMaxSize="2"
            :accept="'.jpg,.jpeg,.png'"
            :value="dialogForm.fileProp"
            :httpRequest="uploadFile"
            :handleRemove="handleRemove"
          >
          </UploadFile>
        </el-form-item>
        <el-form-item label="活动日期范围" required prop="dateRange">
          <el-date-picker
            v-model="dialogForm.dateRange"
            type="daterange"
            align="right"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="dateChange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number 
            v-model="dialogForm.sortValue"
            :min="1"
            controls-position="right"
            size="small"
          />
        </el-form-item>
        <el-form-item label="跳转方式">
          <el-radio-group v-model="dialogForm.radio">
            <el-radio :label="0">不跳转</el-radio>
            <el-radio :label="1">详情图文页</el-radio>
            <el-radio :label="2">指定页面</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="dialogForm.radio == 1" label="" prop="fileProp2">
          <UploadFile
              :limit="9"
              :fileList="fileList2"
              :fileMaxSize="2"
              :multiple="true"
              :accept="'.jpg,.jpeg,.png'"
              :value="dialogForm.fileProp2"
              :httpRequest="uploadFile2"
              :handleRemove="handleRemove2"
            >
            </UploadFile>
        </el-form-item>
        <el-form-item label="url:" v-if="dialogForm.radio == 2" prop="jump_page">
          <el-input
            style="width: 220px"
            v-model="dialogForm.jump_page"
            placeholder="请输入url"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <span class="dialog-footer">
            <el-button @click="reset">取消</el-button>
            <el-button type="primary" @click="submitForm('dialogForm')">提交</el-button>
          </span>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { uploadFiles, createBannerApi, updateBannerApi } from "@/api/radio";
import { transTime } from "@/utils/transTime";
import { getImgName } from "@/utils/cutImgName"
import UploadFile from '@/components/uploadFile.vue'
export default {
  components: {
    UploadFile,
  },
  data() {
    return {
      dialogImageUrl: '',
      transTime,
      getImgName,
      formRule: {
        title: {
          required: true,
          message: "请输入banner名称",
          trigger: "blur",
        },
        jump_page: {
          required: true,
          message: "请输入指定页面url",
          trigger: "blur",
        },
        dateRange: { required: true, message: '请选择时间', trigger: 'change' },
        fileProp: { required: true, message: '请上传文件', trigger: 'change'},
        fileProp2: { required: true, message: '请上传至少一个文件', trigger: 'change'},
      },
      dialogForm: {
        title: '',
        radio: 1,
        fileProp: '',
        fileProp2: '',
        jump_page: '',
        dateRange: [],
        sortValue: '',
      }, // 模态框展示的数据
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      tableData: [],
      remark: null,
      fileList: [],
      fileList2: [],
      start: '',
      end: '',
      type: '',
      id: null,
    };
  },
  created() {
    this.type = this.$route.query.type
    if(this.type == 'edit'){
      // let param = JSON.parse(this.$route.query.row)
      let param = JSON.parse(sessionStorage.getItem('banner'))
      console.log(param)
      this.id = param.id
      this.dialogForm.radio = param.jump_type
      this.dialogForm.title = param.title
      this.dialogForm.fileProp = param.banner_pic
      this.dialogForm.jump_page = param.jump_page
      this.dialogForm.fileProp2 = param.info_page
      this.dialogForm.sortValue = param.order_by
      if(param.info_page){
        this.fileList2 = param.info_page.split(',').map(item => {
          return {
            name: this.getImgName(item),
            url: item,
          }
        })
      }
      this.fileList = [
        {
          name: this.getImgName(param.banner_pic),
          url: param.banner_pic,
        },
      ]
      this.dialogForm.dateRange  = [new Date(param.start_time), new Date(param.end_time)]
      this.start = this.transTime(param.start_time)
      this.end = this.transTime(param.end_time)
      console.log(this.dialogForm)
    } else {
      this.dialogForm.sortValue = Number(this.$route.query.length) + 1
    }
  },
  mounted() {
    // this.previousValue = this.inputValue
  },

  methods: {
    dateChange(val) {
      console.log(val)
      if(val){
        const [start, end] = val
        this.start = start + ' 00:00:00'
        this.end = end + ' 23:59:59'
      } else {
        this.start = ''
        this.end = ''
      }
    },
    uploadFile(params) {
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.fileProp = res.data.filePath
        }
      })
    },
    uploadFile2(params) {
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.fileProp2 = this.dialogForm.fileProp2 ? (this.dialogForm.fileProp2 + ',' + res.data.filePath) : res.data.filePath
          this.fileList2.push({
            url: res.data.filePath,
            name: this.getImgName(res.data.filePath),
          })
        }
      })
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
      this.dialogForm.fileProp = ''
    },
    handleRemove2(file, fileList) {
      const index = this.fileList2.indexOf(file)
      if (index !== -1) {
        this.fileList2.splice(index, 1) // 从列表中移除图片
      }
      if(this.fileList2.length == 0){
        this.dialogForm.fileProp2 = ''
      } else {
        const httpUrls = fileList.map(item => item.url).join(',');
        this.dialogForm.fileProp2 = httpUrls;
      }
    },
    reset(){
      this.$router.go(-1)
    },
    submitForm() {
      console.log(this.type)
      if(this.type == 'add'){
        let param = {
          banner_pic: this.dialogForm.fileProp,
          title: this.dialogForm.title,
          subtitle: '',
          start_time: this.start,
          end_time: this.end,
          order_by: this.dialogForm.sortValue,
          jump_type: this.dialogForm.radio,
          info_page: this.dialogForm.radio == 1 ? this.dialogForm.fileProp2 : '',
          jump_page: this.dialogForm.radio == 2 ? this.dialogForm.jump_page : ''
        }
        this.$refs.dialogForm.validate((valid) => {
          if(valid){
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              createBannerApi(param).then(res => {
                if(res && res.code){
                  this.$router.go(-1)
                }
              })
            })
          }
        })
      } else {
        let param = {
          banner_pic: this.dialogForm.fileProp,
          title: this.dialogForm.title,
          subtitle: '',
          id: this.id,
          start_time: this.start,
          end_time: this.end,
          order_by: this.dialogForm.sortValue,
          jump_type: this.dialogForm.radio,
          info_page: this.dialogForm.radio == 1 ? this.dialogForm.fileProp2 : '',
          jump_page: this.dialogForm.radio == 2 ? this.dialogForm.jump_page : ''
        }
        this.$refs.dialogForm.validate((valid) => {
          if(valid){
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              updateBannerApi(param).then(res => {
                if(res && res.code){
                  this.$router.go(-1)
                }
              })
            })
          }
        })
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 18px;
  font-weight: 700;
}
.titlas {
  display: flex;
  align-items: center;
  margin: 20px 0;
}
.tips {
  color: red;
  font-size: 16px;
  font-weight: 600;
}
.map{
  width: 500px;
  height: 500px;
  position: relative;
  margin: 30px 0 30px 40px;
}
.file-tip{
  color: red;
  font-weight: 600;
}
// .el-form{
//   ::v-deep .el-upload-list{
//     width: 500px;
//   }
// }
.persent{
  color: red;
  font-weight: 600;
  display: inline-block;
  margin-left: 10px;
}
.el-form{
  ::v-deep .el-upload-list{
    // width: 500px;
  }
}
</style>
